"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function csrfToken() {
    return (window || {}).__CSRF_TOKEN || '';
}
exports.csrfToken = csrfToken;
function withCSRFToken(headers) {
    return new Headers(Object.assign({}, headers || {}, { 'x-csrf-token': csrfToken() }));
}
exports.withCSRFToken = withCSRFToken;
